import { Component, Input, ChangeDetectionStrategy, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { NgIf } from '@angular/common';
import { DisplayEventWithTicketControls } from "./shopping-cart-event-list.component"

@Component({
	selector: 'event-list-item',
	templateUrl: "./event-list-item.presentation.html",
	styles: [require("./event-list-item.presentation.scss")]
})
export class EventListItem {

	@Output() removeTickets = new EventEmitter<string[]>();
	@Output() eventTitleClicked = new EventEmitter<number>();

	@Input() displayEventWithTicketControls: DisplayEventWithTicketControls

	@Input() set editable(editable: boolean) {
		if (editable) {
			this.showEditable = true
		}
	}

	private showEditable: boolean = false

	constructor(

	) { }

	processRemoveTickets(ticketItemUuidsToBeRemoved: string[]) {
		this.removeTickets.emit(ticketItemUuidsToBeRemoved)
	}
}



// WEBPACK FOOTER //
// ./src/app/components/shopping-cart/shopping-cart-event-list/event-list-item.presentation.ts